import React from 'react';
import { Dialog } from 'primereact/dialog';

/**
 * Dialog base usado para englobar a página de lançamentos avulsos.
 */
export default function DialogLancamentoWrapper({ visible, onHide, onShow, children, title }) {
  return (
    <Dialog
      header={title}
      visible={visible}
      onHide={onHide}
      onShow={onShow}
      modal
      dismissableMask
      className="w-[90vw] md:w-[75vw] max-w-[1000px]"
      breakpoints={{ '960px': '90vw', '640px': '95vw' }}
    >
      <div className="max-h-[75vh] overflow-y-auto pr-2">
        {children}
      </div>
    </Dialog>
  );
}
